import { createFileRoute } from '@tanstack/react-router';
import { SheetFormPage } from '../../sheet-form/SheetFormPage.js';
import { validateSheetSearch } from '../../sheet-form/search.js';

/** `/sheets/$docId` (1.AC-2): the stat-block form of one page. */
export const Route = createFileRoute('/sheets/$docId')({
  validateSearch: validateSheetSearch,
  component: SheetFormRoute,
});

function SheetFormRoute(): React.JSX.Element {
  const { docId } = Route.useParams();
  const { sheet, compare } = Route.useSearch();
  return (
    <main className="cx-sf-page">
      <SheetFormPage docId={docId} sheetId={sheet} compare={compare === 1} />
    </main>
  );
}
